import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const linxIntegrationSchema = z.object({
  id: zExt.objectId(),
  enabled: z.boolean(),
});

export const linxSettingsInputSchema = z.object({ enabled: z.boolean() });
